import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthStatus, useAuthContext } from "../hooks/useAuthContext";
import { Ripple } from "primereact/ripple";
import MeaTopNavbar from "./components/MeaTopNavbar";
import { useEffect } from "react";

export function UserLayout() {
  const { account, status } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (status === AuthStatus.GUEST) {
      navigate("/auth/login", { state: { from: location } });
    }
  }, [status]);


  const MainNavLink = ({ label, icon, to }) => {
    return (
      <NavLink
        to={to}
        className={({ isActive, isPending }) =>
          'no-underline text-color p-ripple border-round-top flex align-items-center px-6 py-3 lg:px-3 lg:py-3 font-medium cursor-pointer transition-colors transition-duration-150 ' + (isActive ? 'bg-teal-100 text-900' : 'hover:surface-hover')
        }
        onClick={() => {
          const element = document.getElementById('mea-main-navigation');
          if (element) {
            element.classList.add('hidden');
          }
        }}
      >
        <i className={"pi mr-2 " + icon}></i>
        <span>{label}</span>
        <Ripple />
      </NavLink>
    )
  }
  return (
    <div style={{ height: "100vh" }}>
      <div className="min-h-screen flex flex-column ">
        <MeaTopNavbar mainMenu={
          <ul className="list-none p-0 m-0 flex select-none flex-column lg:flex-row gap-2">
            <li className="lg:flex lg:align-items-end">
              {MainNavLink({ label: "Mon profil", icon: "pi pi-user", to: "/user/profile" })}
            </li>
            <li className="lg:flex lg:align-items-end">
              {MainNavLink({ label: "Mes écoles", icon: "pi pi-school", to: "/user/schools" })}
            </li>
          </ul>
        } />
        <div className="flex flex-column flex-auto">
          <Outlet />
        </div>
      </div>
    </div>
  )
}